import React, { PureComponent } from 'react';

import './BasketSofaglide.scss';

import { formatCurrency } from 'formatters';

const SOFAGLIDE_IMAGE_SRC = 'https://images.sofology.co.uk/image/upload/c_scale/h_150/v1566202282/Sofaglide_Blk_kbbvss.png';

interface OwnProps {
    priceValue: number;
    range: string;
    sofaglideParentCode: string;
    onRemove?: (sofaglideParentCode: string) => void;
    loading: boolean;
}

export class BasketSofaglide extends PureComponent<OwnProps> {
    handleRemoveClick = () => {
        this.props.onRemove && this.props.onRemove(this.props.sofaglideParentCode);
    };

    render(): JSX.Element {
        const { loading } = this.props;

        return (
            <div className='sofaglide-wrapper'>
                {this.renderContent()}
                {loading && <div className='sofaglide-wrapper__overlay'></div>}
            </div>
        );
    }

    renderContent(): JSX.Element {
        const { priceValue, range, onRemove } = this.props;
        const shouldShowRemoveButton = onRemove !== undefined;

        return (
            <>
                <div className='sofaglide-wrapper__image'>
                    <img src={SOFAGLIDE_IMAGE_SRC} alt='sofaglide' />
                </div>
                <div className='sofaglide-wrapper__description'>
                    Sofaglide for
                    <span className='sofaglide-wrapper__description__range'> {range}</span>
                </div>
                <div className='sofaglide-wrapper__additional'>
                    <div className='sofaglide-wrapper__additional__currency'>{formatCurrency(priceValue, 0)}</div>
                    {shouldShowRemoveButton && <button className='sofaglide-wrapper__additional__remove' onClick={this.handleRemoveClick}>remove</button>}
                </div>
            </>
        );
    }
}